import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BaseDialogOptions } from '../dialogoptions';

@Component({
    selector: 'dialog-selectbox-component',
    styleUrls: ['selectbox.dialogcomponent.css'],
    templateUrl: 'selectbox.dialogcomponent.html'
})
export class SelectBoxDialogComponent implements OnInit {
    title: string;
    message: string;
    oktext: string;
    canceltext: string;
    options: BaseSelectBoxSelectionOption[];
    current: number;
    selection: number;
    showIcon: boolean;

    constructor(private dialogRef: MatDialogRef<SelectBoxDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: BaseSelectBoxDialogOptions) {
        this.title = data.TitleText || 'Information';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.options = data.Options || <BaseSelectBoxSelectionOption[]>[];
        this.current = data.Current;
        this.selection = data.Current;
        this.showIcon = data.ShowIcon;
    }

    ngOnInit() {
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    OKHandler() {
        this.dialogRef.close(this.selection);
    }
}

export class BaseSelectBoxDialogOptions extends BaseDialogOptions {
    Options ?: BaseSelectBoxSelectionOption[];
    Current ?: number;
}

export class BaseSelectBoxSelectionOption {
    Text: string;
    Value: any;
}
